import { prestigeClient } from "..";
import { QueryBuilder } from "../../../lib/directus-sdk/query-builder";

const prestigeDecorativeBuilder = new QueryBuilder("prestige_content")
  .select(["name", { image: ["id", "title"] }])
  .where({
    name: { _contains: "prestige.decorative" },
  });

const prestigeBenefitsBuilder = new QueryBuilder("prestige_content").select([
  "name",
  { image: ["id", "title"] },
  {
    translations: {
      fields: ["text"],
    },
  },
]);

const prestigeTextBuilder = new QueryBuilder("prestige_content").select([
  "name",
  {
    translations: {
      fields: ["text"],
    },
  },
]);

export const prestigeDecorativeClient = prestigeClient
  .query(prestigeDecorativeBuilder)
  .key("prestige_decorative");
export const prestigeBenefitsClient = prestigeClient
  .query(prestigeBenefitsBuilder)
  .key("prestige_benefits");
export const prestigeTextClient = prestigeClient
  .query(prestigeTextBuilder)
  .key("prestige_text");

export const prestigeContentDefaultData = {
  "prestige.[silver/gold/diamond/platinum].benefits_1": "Welcome Bonus",
  "prestige.[silver/gold/diamond/platinum].benefits_2": "Birthday Bonus",
  "prestige.[silver].benefits_3": "Exclusive Silver VIP bonuses",
  "prestige.[gold].benefits_3": "Exclusive Gold VIP bonuses",
  "prestige.[diamond].benefits_3": "Exclusive Diamond VIP bonuses",
  "prestige.[platinum].benefits_3": "Exclusive Platinum VIP bonuses",
  "prestige.[gold/diamond/platinum].benefits_4": "Less Withdrawal Fee",
  "prestige.[gold/diamond/platinum].benefits_5": "Personal VIP Manager",
  "prestige.[gold/diamond/platinum].benefits_6": "Fast track withdrawal",
  "prestige.[diamond/platinum].benefits_7": "Higher betting limits*",
  "prestige.[diamond].benefits_7-2":
    "Qualified Diamond VIP accounts may be granted higher betting limits",
  "prestige.[platinum].benefits_7-2":
    "Qualified Platinum VIP accounts may be granted higher betting limits",
  "pretige.text.claim.now": "Claim Now",
  "prestige.text.vip.level.diamond": "Diamond VIP Level",
  "prestige.text.vip.level.gold": "Gold VIP Level",
  "prestige.text.vip.level.platinum": "Platinum VIP Level",
  "prestige.text.vip.level.silver": "Silver VIP Level",
  "prestige.text.vip.benefits.diamond": "Diamond VIP Benefits",
  "prestige.text.vip.benefits.gold": "Gold VIP Benefits",
  "prestige.text.vip.benefits.platinum": "Platinum VIP Benefits",
  "prestige.text.vip.benefits.silver": "Silver VIP Benefits",
};



// WEBPACK FOOTER //
// ./src/app/common/directus/prestige/prestige_content.js